import { ReactNode } from 'react';
import Banner from './banner';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Carousel from '@/containers/carousel';

type BannerImages = {
  image: string | StaticImport;
  title?: string;
  subtitle?: string;
  align?: 'left' | 'right' | 'center';
};
type PageContainerProps = {
  children: ReactNode;
  pageTitle: string;
  pageDesc?: string;
  pageImg?: string | StaticImport;
  bannerImages?: BannerImages[] | null;
};

export default function PageContainer({
  children,
  pageDesc,
  pageTitle,
  pageImg,
  bannerImages,
}: PageContainerProps) {
  return (
    <div className="w-full p-5 pb-20">
      {bannerImages ? (
        <Carousel>
          {bannerImages.map((data, index) => (
            <Banner
              key={index}
              img={data.image}
              title={data.title}
              align={data.align}
              bright
            />
          ))}
        </Carousel>
      ) : (
        <div className="p-5 pb-20 grid gap-20">
          <Banner title={pageTitle} description={pageDesc} img={pageImg} />
        </div>
      )}
      <>{children}</>
    </div>
  );
}
